module.exports = __webpack_public_path__ + "img/candy-island.9538de89.png";